var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"puzzle"},_vm._l((_vm.puzzles),function(day,index){return _c('div',{key:index,staticClass:"puzzle_item"},[_c('p',{staticClass:"order"},[_c('span',[_vm._v(" "+_vm._s(day.date.day)+" ")])]),_c('div',{staticClass:"content"},[_c('IconLamp'),(day.homework)?_c('button',{staticClass:"_btn _btn-remove",on:{"click":function($event){return _vm.$emit('openModalDelete', day.homework.id)}}},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}})]):_vm._e(),(day.homework)?_c('button',{staticClass:"_btn _btn-copy",on:{"click":function($event){return _vm.$emit('openModalCopy', {
					id: day.homework.id,
					order: day.order,
					slide: _vm.slide,
				})}}},[_c('i',{staticClass:"fa fa-clone",attrs:{"aria-hidden":"true"}})]):_vm._e(),(day.homework)?_c('span',{staticClass:"current-date"},[_vm._v(" "+_vm._s(_vm._f("getCurrentDate")(day.homework.created))+" ")]):_vm._e(),(day.homework)?_c('router-link',{staticClass:"_button",attrs:{"to":{
				name: ((_vm.$route.fullPath.indexOf('group') >= 0 ? 'Group' : 'Profile') + " Homework Create"),
				params: { id: _vm.$route.params.id },
				query: {
					homework: day.homework.id,
					date: day.formattedDate,
					order: day.order,
				},
			}}},[_vm._v(" "+_vm._s(_vm._f("translate")('Edit'))+" ")]):(!day.homework)?_c('router-link',{staticClass:"_button",attrs:{"to":{
				name: ((_vm.$route.fullPath.indexOf('group') >= 0 ? 'Group' : 'Profile') + " Homework Create"),
				params: { id: _vm.$route.params.id },
				query: {
					date: day.formattedDate,
					order: day.order,
				},
			}}},[_vm._v(" "+_vm._s(_vm._f("translate")('Create'))+" ")]):_vm._e()],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }